import { render, staticRenderFns } from "./Issued.vue?vue&type=template&id=2a75bfb0"
import script from "./Issued.vue?vue&type=script&lang=js"
export * from "./Issued.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports